/**
 * @description
 * Serializes an object into a query parameter string compatible with URLSearchParams.
 * 
 * @example
 * ```typescript
 * const params = {
 * 	id: 1,
 * 	ids: [1, 2, 3],
 * 	name: 'test',
 * 	undefinedValue: undefined,
 * 	nullValue: null
 * };
 * 
 * const serialized = serializeParams(params);
 * serialized is "id=1&ids=1&ids=2&ids=3&name=test"
 * ```
 * 
 * @param params - An object containing key-value pairs to serialize.
 * @returns A URL-encoded string of parameters.
 */
export function serializeParams(params: Record<string, unknown>): string {
	const search = new URLSearchParams();

	for (const [key, value] of Object.entries(params)) {
		if (value === null || value === undefined) continue;

		if (Array.isArray(value)) {
			for (const v of value) {
				search.append(key, String(v));
			}
		} else {
			search.append(key, String(value));
		}
	}

	return search.toString();
}
